import { render, staticRenderFns } from "./SubAccountsTable.vue?vue&type=template&id=2e7cd96a&scoped=true&"
import script from "./SubAccountsTable.vue?vue&type=script&lang=js&"
export * from "./SubAccountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7cd96a",
  null
  
)

export default component.exports